import { z } from 'zod/v4';

/** The calculations a refresh can recompute for an order's tracing link. */
export const TRACING_ORDER_REFRESH_EVENTS = [
  'ORDER_DEPTH',
  'DOCUMENT_PERCENTAGE',
] as const;

export type TracingOrderRefreshEvent =
  (typeof TRACING_ORDER_REFRESH_EVENTS)[number];

const isUnique = (items: unknown[]) => new Set(items).size === items.length;

export const BulkRefreshCalculationBodySchema = z.object({
  /** At least one, none empty, no repeats. Any company's orders, as in legacy. */
  orderIds: z
    .array(z.string().min(1))
    .min(1)
    .refine(isUnique, { message: 'orderIds must be unique' }),
  /** Which side `orderIds` are on. */
  type: z.enum(['PURCHASE_ORDER', 'SALES_ORDER']),
  /** At least one, no repeats. */
  events: z
    .array(z.enum(TRACING_ORDER_REFRESH_EVENTS))
    .min(1)
    .refine(isUnique, { message: 'events must be unique' }),
});

export type BulkRefreshCalculationBody = z.infer<
  typeof BulkRefreshCalculationBodySchema
>;
